import { Link, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { api } from '../../services/api';
import { useAsync } from '../../hooks/useAsync';
import { dateTime, usd } from '../../services/format';
import { Alert, Badge, Cell, PageTitle, Row, Table } from '../../components/ui';
import { stateTone } from './common';

/** Every staff sandbox (sculpt-api `GET /admin/sandboxes`), newest activity first. */
export function SandboxesList() {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const { data, error, loading } = useAsync(() => api.sandboxes(), []);
  return (
    <div>
      <PageTitle title={t('sandbox.listTitle')} subtitle={t('sandbox.listSubtitle')} />
      {error && <Alert>{error}</Alert>}
      <Table head={[t('sandbox.conversation'), t('sandbox.staff'), t('sandbox.model'), t('sandbox.turnsPlayed'), t('sandbox.cost'), t('sandbox.state'), t('sandbox.lastActivity')]}
             empty={!loading && !data?.length ? t('sandbox.none') : undefined}>
        {(data ?? []).map((s) => (
          <Row key={s.id} onClick={() => navigate(`/sandboxes/${s.id}`)}>
            <Cell><Link to={`/sandboxes/${s.id}`} className="underline">{s.source_title ?? s.source_thread_id}</Link></Cell>
            <Cell>{s.staff_email ?? '—'}</Cell>
            <Cell mono>{s.model}</Cell>
            <Cell mono>{t('sandbox.fromTo', { from: s.from_turn, next: s.next_turn })}</Cell>
            <Cell mono>{usd(s.cost_usd, i18n.language)}</Cell>
            <Cell><Badge tone={stateTone(s.state)}>{t(`sandbox.states.${s.state}`)}</Badge></Cell>
            <Cell mono>{dateTime(s.last_activity_at, i18n.language)}</Cell>
          </Row>
        ))}
      </Table>
    </div>
  );
}
